function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .gy {\n                clip-path: url(#a);\n            }\n\n            .gz {\n                stroke-width: 0.5px;\n                stroke: #000;\n            }\n\n            .gzz {\n                stroke: #000;\n                fill: none;\n                stroke-linecap: round;\n                stroke-width: 1.5px;\n            }\n        "), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  transform: "translate(8.25 8.25)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-698.939 -458.939)"
}, /*#__PURE__*/React.createElement("g", {
  className: "gy",
  transform: "translate(690.75 450.75)"
}, /*#__PURE__*/React.createElement("path", {
  className: "gz",
  d: "M31.011,12.584a.488.488,0,0,0-.482-.009l-5.277,2.882V13.728a2.439,2.439,0,0,0-2.436-2.436H10.686A2.439,2.439,0,0,0,8.25,13.728v9.62a2.439,2.439,0,0,0,2.436,2.436H22.815a2.439,2.439,0,0,0,2.436-2.436v-1.7l5.277,2.881a.487.487,0,0,0,.721-.428V13a.487.487,0,0,0-.239-.419ZM24.277,23.348a1.463,1.463,0,0,1-1.462,1.462H10.686a1.463,1.463,0,0,1-1.462-1.462v-9.62a1.464,1.464,0,0,1,1.462-1.462H22.815a1.464,1.464,0,0,1,1.462,1.462Zm6-.065L25.252,20.54V16.567l5.024-2.743Z",
  transform: "translate(0 1.198)"
})), /*#__PURE__*/React.createElement("line", {
  className: "gzz",
  x1: 21,
  y2: 21,
  transform: "translate(700 460)"
}));

function SvgVideoOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.121,
    height: 23.121,
    viewBox: "0 0 23.121 23.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video_off.b7715019.svg";
export { ForwardRef as ReactComponent };